import { setContext } from '@apollo/client/link/context';
import { getStorage } from '#utils/storage';

export const createInstallationLink = () => setContext((_, { headers }) => {
  const storage = getStorage();
  const currentInstallationId = storage.get('currentInstallationId');

  return {
    headers: {
      ...headers,
      ...(currentInstallationId && { 'Installation-Id': currentInstallationId }),
    },
  };
});
